import { put, call } from 'redux-saga/effects';
import { aflt_appayrateList, aflt_appayrateAdd, aflt_appayrateUpdate, aflt_appayrateDelete } from '../../../services/settings/affiliates/aflt_appayrateService';

import * as types from '../../../actions';

export function* aflt_appayrateListSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_appayrateList, payload);
      yield put({ type: types.APPAYRATE_LIST_AFFILIATE_SUCCESS, response })
      
    } catch(error) {
      yield put({ type: types.APPAYRATE_LIST_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_appayrateAddSaga(payload) { 
    try {
      yield put({ type: types.SHOW_LOADER})
      const response = yield call(aflt_appayrateAdd, payload);
      yield put({ type: types.APPAYRATE_ADD_AFFILIATE_SUCCESS, response })
            
    } catch(error) {
      yield put({ type: types.APPAYRATE_ADD_AFFILIATE_ERROR, error });
    }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_appayrateUpdateSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_appayrateUpdate, payload);
    yield put({ type: types.APPAYRATE_UPDATE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.APPAYRATE_UPDATE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}

export function* aflt_appayrateDeleteSaga(payload) {
  try {
    yield put({ type: types.SHOW_LOADER})
    const response = yield call(aflt_appayrateDelete, payload);
    yield put({ type: types.APPAYRATE_DELETE_AFFILIATE_SUCCESS, response })
          
  } catch(error) {
    yield put({ type: types.APPAYRATE_DELETE_AFFILIATE_ERROR, error });
  }finally{
      yield put({ type: types.HIDE_LOADER})
  }
}


